import { createFileRoute } from "@tanstack/react-router";
import { Require } from "../features/require";
import { StaffPage } from "../features/staff/staff-page";

export const Route = createFileRoute("/more/staff")({ component: Page });

function Page() {
	return (
		<Require permission="staff.manage">
			<StaffPage />
		</Require>
	);
}
